const swalMessages = {
    methods: {
        showLoadingMessage()  {
            this.$swal.fire({
                icon: 'info',
                title: 'Please Wait!',
                html: 'Your information is being uploaded',
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading()
                }
            });
        },
        showSuccessMessage(text) {
            this.$swal.fire({
                icon: 'success',
                title: `Success!`,
                text,
            })
        },
        showInfoMessage(title, text = null, html = null) {
            this.$swal.fire({
                icon: 'info',
                title,
                text,
                html,
            })
        },
        showErrorMessage(text) {
            this.$swal.fire({
                icon: 'error',
                title: `Error!`,
                text,
            })
        },
        showValidationErrorMessage(errors) {
            this.$swal.fire({
                icon: 'error',
                title: `Information is required!`,
                text: errors.join(', '),
            })
        },
    }
}

export default swalMessages
